var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.4775 108C52.6275 108 46.2425 102.048 46.2425 94.73H52.2425C52.2425 98.74 55.9375 102 60.4775 102C65.0175 102 68.7125 98.7375 68.7125 94.73H74.7125C74.7125 102.048 68.3275 108 60.4775 108Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.52 97.55H27.5125C22.835 97.55 19.0325 93.9575 19.0325 89.54C19.0325 85.1225 22.675 81.685 27.215 81.535V56.8675C27.215 39.96 42.1375 26.205 60.4775 26.205C78.8175 26.205 93.74 39.96 93.74 56.8675V81.535C98.275 81.68 101.877 85.1075 102 89.4575V89.5425C102 93.96 98.1975 97.5525 93.52 97.5525V97.55ZM27.5125 87.53C26.1675 87.53 25.0325 88.45 25.0325 89.54C25.0325 90.63 26.1675 91.55 27.5125 91.55H93.52C94.8475 91.55 95.9725 90.6525 96 89.5825C95.94 88.4475 94.8025 87.5325 93.44 87.5325H87.74V56.87C87.74 43.27 75.51 32.2075 60.4775 32.2075C45.445 32.2075 33.215 43.27 33.215 56.87V87.5325H27.5125V87.53Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.43 32.17C54.5025 32.17 49.6775 27.645 49.6775 22.085C49.6775 16.525 54.5 12 60.43 12C66.36 12 71.1825 16.525 71.1825 22.085C71.1825 27.645 66.36 32.17 60.43 32.17ZM60.43 18C57.81 18 55.6775 19.8325 55.6775 22.085C55.6775 24.3375 57.81 26.17 60.43 26.17C63.05 26.17 65.1825 24.3375 65.1825 22.085C65.1825 19.8325 63.05 18 60.43 18Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/NotificationBell.7760bcc1.svg";
export { ForwardRef as ReactComponent };